import { ProgressStatus, CleaningStatus, TransactionProbability, OrderStatus, PotentialStatus } from '@/model/sale';

export enum MaterialType {
  sales = 'MATERIAL_SALES',
  unknown = 'MATERIAL_UNKNOWN', // 未知
  neighbor = 'MATERIAL_NEIGHBORHOOD', // 附近推
  normalFollow = 'MATERIAL_NORMAL_FOLLOW', // 常规广告
  product = 'MATERIAL_PRODUCT_FUNC', // 产品功能
  finance = 'MATERIAL_FINANCE_FLOW', // 广告链路
  adCreate = 'MATERIAL_AD_CREATE', // 广告开户
  adPut = 'MATERIAL_AD_PUT', // 广告投放
  saleActivity = 'MATERIAL_SALE_ACTIVITY', // 促销活动
  adCase = 'MATERIAL_AD_CASE', // 广告案例
  industrySolutions = 'MATERIAL_INDUSTRY_SOLUTIONS', // 行业解决方案
  customerRelationShip = 'MATERIAL_CUSTOMER_RELATIONSHIP', // 客情关系
  batch = 'MATERIAL_BATCH', // 群发素材
}

export enum MaterialCreatorType {
  unknown = 'MATERIAL_CREATOR_UNKNOW',
  official = 'MATERIAL_CREATOR_OFFICIAL',
  corp = 'MATERIAL_CREATOR_CORP',
};

export interface SendSuggestionItem {
  industryIds: Array<number>;
  areaIds: Array<number>;
  intentions: Array<{ adPlatformType: string, promotedObject?: string }>;
  leadSourceTypes: Array<string>;
  systemSourceTypes: Array<string>;
  sourceTypeTags: Array<number>;
  progressStatuses: Array<ProgressStatus>;
  cleaningStatuses: Array<CleaningStatus>;
  potentialStatuses: Array<PotentialStatus>;
  transactionProbabilities: Array<TransactionProbability>;
  orderStatuses: Array<OrderStatus>;
}

export interface SendSuggestionEdit {
  industryIds: Array<number>;
  areaIds: Array<number>;
  intentions: Array<string>;
  systemSourceTypes: Array<string>;
  sourceTypeTags: Array<number>;
  progressStatuses: Array<ProgressStatus>;
  combineStatuses?: Array<CleaningStatus | PotentialStatus | TransactionProbability | OrderStatus>
}

export enum MaterialContentType {
  image = 'MATERIAL_CONTENT_IMAGE',
  video = 'MATERIAL_CONTENT_VIDEO',
  file = 'MATERIAL_CONTENT_FILE',
  url = 'MATERIAL_CONTENT_URL',
};

export interface MaterialContentItem {
  contentType: MaterialContentType;
  url?: string;
  title?: string;
  picurl?: string;
  desc?: string;
  status?: 'success' | 'fail' | 'loading',
  errorMsg?: string,
}

export interface MaterialDetailItem {
  textMessage: string;
  fileItems: Array<MaterialContentItem>;
}

export interface Material {
  materialId: number;
  materialTitle: string;
  materialType: MaterialType;
  creatorType: MaterialCreatorType;
  sendSuggestion: SendSuggestionItem;
  materialDetails: MaterialDetailItem;
  visibleAgency: Array<number>;
  lastModTime?: string;
  lastModUserName?: string;
  quoteTimes?: number;
};

export interface MaterialEdit {
  materialId: number;
  materialTitle: string;
  materialType: MaterialType;
  creatorType: MaterialCreatorType;
  sendSuggestion: SendSuggestionItem;
  visibleAgency: Array<number>;
  quoteDetails: Array<QuoteInfoItem>;
  textMessage: string;
  fileItems: Array<MaterialContentItem>;
};

export interface QuoteInfoItem {
  quoteTimes: number;
  agencyId?: number;
  agencyName?: string;
  employeeId?: number;
  employeeName?: string;
};

export enum GroupMessageStatus {
  unknown = 'GROUP_MSG_UNKNOWN', // 未知
  sending = 'GROUP_MSG_SENDING', // 发送中
  alreadySend = 'GROUP_MSG_ALREADY_SEND', // 已发送
};

export enum GroupMessageSendStatus {
  notSend = 'GROUP_MSG_EMPLOYEE_NOT_SEND', // 未发送
  alreadySend = 'GROUP_MSG_EMPLOYEE_ALREADY_SEND', // 已发送
};

export type SendScopeItem = SendSuggestionItem & {
  employeeIds: Array<number>;
  teamIds: Array<number>;
};

export interface GroupMessage {
  groupMsgId: number;
  materialId: number;
  material: {
    agencyId: number;
    materialId: number;
    materialTitle: string;
    materialType: MaterialType;
    creatorType: MaterialCreatorType;
  };
  sendScope: SendScopeItem;
  excludeSendScope: SendScopeItem;
  materialDetails: MaterialDetailItem;
  createdByUserId: number;
  createdTime: string;
  status: GroupMessageStatus;
  allEmployeeIds: Array<number>;
  allEmployeeCnt: number;
  sendedEmployeeIdCnt: number;
  allCustomerCnt: number;
  successCustomerCnt: number;
};

export interface GroupMessageEdit {
  groupMsgId: number;
  materialId: number;
  material: {
    agencyId: number;
    materialId: number;
    materialTitle: string;
    materialType: MaterialType;
    creatorType: MaterialCreatorType;
  };
  sendScope: SendScopeItem;
  excludeSendScope: SendScopeItem;
  executeInfo: Array<ExecuteInfoItem>;
  textMessage: string;
  fileItems: Array<MaterialContentItem>;
  employeeIds: Array<number>;
  excludeEmployeeIds: Array<number>;
  needExcludeSendScope: Array<number>;
  needExcludeEmployeeIds: Array<number>;
};

export interface ExecuteInfoItem {
  msgId: string;
  result: Array<{
    agencyId: number,
    employeeId: number,
    employeeName: string,
    allCustomerCnt: number,
    successCustomerCnt: number,
    status: GroupMessageSendStatus,
  }>
}
